<template>
  <users-input-list-item
    v-bind="$props"
    :items="dots"
    :group="name"
    @managePermissions="emitEvent('managePermissions')"
    @edit="emitEvent('edit')"
    @delete="emitEvent('delete')"
    @copy="emitEvent('copy')"
    :is-groups="true"
  >
  </users-input-list-item>
</template>

<script>
import UsersInputListItem from '@/components/UsersInputListItem';

export default {
  name: 'UsersInputListItemWrapper',
  components: {
    UsersInputListItem,
  },
  props: {
    color: {
      type: String,
      required: true,
    },
    is_admin_group: {
      type: Boolean,
      required: true,
    },
    id: {
      type: Number,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
  },
  computed: {
    dots() {
      const items = [
        {
          name: 'managePermissions',
        },
        {
          name: 'edit',
        },
        {
          name: 'copy',
        },
        {
          name: 'delete',
        },
      ];
      if (this.is_admin_group) {
        return items.filter(item => item.name === 'copy');
      }
      return items;
    },
  },
  methods: {
    emitEvent(type) {
      this.$emit('dotsItemClicked', { type, id: this.id });
    },
  },
};
</script>

<style lang="scss" scoped></style>
